enum Transition {
    Raw = 'none',
    Smooth = 'smooth'
}

export default Transition
